import * as types from './types';

export const actionClientsGet = () => ({ type: types.CLIENTS_GET._REQUEST });

export const actionClientsSetFilter = (search) => ({
  type: types.CLIENTS_SET_FILTER,
  payload: search,
});

export const actionClientPost = (payload) => ({
  type: types.CLIENT_CREATE_NEW_POST._REQUEST,
  payload,
});

export const actionAccountOwnersGet = (accountId) => ({
  type: types.ACCOUNT_OWNERS_GET._REQUEST,
  payload: { accountId },
});

export const actionAccountOwnersPatch = (payload) => ({
  type: types.ACCOUNT_OWNERS_PATCH._REQUEST,
  payload,
});

export const actionClientDetailsGet = (clientId) => ({
  type: types.CLIENT_DETAILS_GET._REQUEST,
  payload: { clientId },
});

export const actionClientAccountsGet = (clientId) => ({
  type: types.CLIENT_ACCOUNTS_GET._REQUEST,
  payload: { clientId },
});

export const actionClientDetailsPatch = (clientId, { allowFaOnboarding }) => ({
  type: types.CLIENT_DETAILS_PATCH._REQUEST,
  payload: { clientId, allowFaOnboarding },
});

export const actionClientAssetsBreakdownGet = (clientId, breakdownTypes, relationshipType) => ({
  type: types.CLIENT_ASSETS_BREAKDOWN_GET._REQUEST,
  payload: { clientId, types: breakdownTypes, relationshipType },
});
